import React from 'react';
export function WhatYouGet() {
  const tomos = [{
    color: '#22C55E',
    title: 'TOMO 1 — Enero/Feb — Cimientos y Cardio-Box',
    desc: '24 sesiones · Guardia, jab, cross, hook, uppercut y primeras combinaciones'
  }, {
    color: '#EAB308',
    title: 'TOMO 2 — Marzo/Abr — Técnica de Base Avanzada',
    desc: '24 sesiones · Jab táctico, ataque multinivel, defensa básica y guanteo técnico'
  }, {
    color: '#D97706',
    title: 'TOMO 3 — Mayo/Jun — Ataque y Potencia Real',
    desc: '24 sesiones · Cadena cinética, las 5 combinaciones de KO y velocidad de manos'
  }, {
    color: '#EF4444',
    title: 'TOMO 4 — Julio/Ago — Defensa Avanzada',
    desc: '24 sesiones · Los 7 sistemas defensivos, contraataque automático y corner work'
  }, {
    color: '#A855F7',
    title: 'TOMO 5 — Sep/Oct — Sparring y Táctica de Combate',
    desc: '24 sesiones · Plan A + Plan B, análisis del rival y gestión de rounds'
  }, {
    color: '#FACC15',
    icon: '⭐',
    title: 'TOMO 6 — Nov/Dic — Especialización, Legado y Cierre',
    desc: 'Estilo personal · Mentoring · Combinación propia · Cierre del año y La Gran Velada'
  }];
  const includes = [{
    title: 'Planificación bimestral lista',
    desc: 'Sin adaptar ni inventar nada'
  }, {
    title: 'Clases Round-by-Round completas',
    desc: 'Objetivo, desarrollo y cierre en cada clase'
  }, {
    title: 'Sistema 3-1-1',
    desc: 'Lo lees 5 minutos antes y ejecutas'
  }, {
    title: 'Tests de nivelación y progreso',
    desc: 'Sabes exactamente dónde está cada alumno'
  }, {
    title: 'Fichas de seguimiento individual',
    desc: 'Progresión visible y medible'
  }, {
    title: 'Variantes por nivel',
    desc: 'Una clase para todos los niveles simultáneamente'
  }, {
    title: 'Adaptaciones para poco espacio',
    desc: 'Nunca más cancelas por imprevistos'
  }, {
    title: '5 eventos internos completos',
    desc: 'Torneos y veladas que fidelizan como nada más'
  }, {
    title: 'Lenguaje neutro hispanohablante',
    desc: 'Funciona en México, Colombia, España, Chile y más'
  }];
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-295">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-296">
        <div className="bg-black border border-gray-800 rounded-2xl p-6 sm:p-10" data-id="element-297">
          <h2 className="text-2xl sm:text-3xl font-black text-[#F97316] mb-1" data-id="element-298">
            📘 LOS 6 TOMOS
          </h2>
          <p className="text-gray-400 text-sm sm:text-base mb-8" data-id="element-299">
            Para entrenadores de boxeo de todos los niveles
          </p>

          <div className="space-y-8" data-id="element-300">
            {tomos.map((tomo, i) => <div key={i} className="flex items-start gap-4" data-id="element-301">
                <div className="flex-shrink-0 mt-1" data-id="element-302">
                  {tomo.icon ? <span className="text-2xl" data-id="element-303">{tomo.icon}</span> : <div className="w-6 h-6 rounded-full" style={{
                backgroundColor: tomo.color
              }} data-id="element-304" />}
                </div>
                <div data-id="element-305">
                  <h3 className="text-white text-lg sm:text-xl font-black leading-tight mb-1" data-id="element-306">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-300 text-sm sm:text-base leading-relaxed" data-id="element-307">
                    {tomo.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="bg-[#1a0f00] border border-[#F97316]/30 rounded-2xl p-6 sm:p-10" data-id="element-308">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-8" data-id="element-309">
            📦 CADA TOMO INCLUYE:
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-310">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-311">
                <span className="text-[#F97316] flex-shrink-0 mt-0.5" data-id="element-312">✅</span>
                <div data-id="element-313">
                  <h4 className="text-white font-bold text-sm sm:text-base" data-id="element-314">
                    {item.title}
                  </h4>
                  <p className="text-gray-400 text-xs sm:text-sm mt-1" data-id="element-315">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}